import React from 'react'
import { RouteObject } from 'react-router-dom'

import { MainLayout } from '@components/systems'
import { AccessGuard } from '@guards'

import AdminHomePage from '@pages/admin/AdminHome.page'
import AccessControlPage from '@pages/admin/AccessControl.page'
import MenuManagementPage from '@pages/admin/MenuManagement.page'
import CreateMenuPage from '@pages/admin/CreateMenu.page'
import AdminUsersPage from '@pages/admin/AdminUsers.page'

import ResetPasswordPage from '@pages/admin/ResetPassword.page'
import UserProfileImageUpdatePage from '@pages/admin/UserProfileImageUpdate.page'
// @PLOP-IMPORTS

/* eslint-disable */
const AdminRoute: RouteObject[] = [
	{
		path: '/admin',
		element: (
			<AccessGuard>
				<MainLayout />
			</AccessGuard>
		),
		children: [
			{
				path: '/admin/empty',
				element: <></>,
			},
			{
				path: '/admin/home',
				element: <AdminHomePage />,
			},
			{
				path: '/admin/access-control',
				element: <AccessControlPage />,
			},
			{
				path: '/admin/menu',
				element: <MenuManagementPage />,
			},
			{
				path: '/admin/users',
				element: <AdminUsersPage />,
			},
			// @PLOP-CODE
		],
	},
	{
		path: '/admin/reset-password',
		element: (
			<AccessGuard>
				<ResetPasswordPage />
			</AccessGuard>
		),
	},
	{
		path: '/admin/user-profile-image-update',
		element: (
			<AccessGuard>
				<UserProfileImageUpdatePage />
			</AccessGuard>
		),
	},
	{
		path: '/admin/create-menu',
		element: <CreateMenuPage />,
	},
]

export default AdminRoute
